import { useContext } from "react";

import { Heading, Image } from "capitalrx-components-2.0";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";

import { ThemeSelectorContext } from "@/context/index";
import pillBottles from "@/static/images/pill_bottles.png";
import CapRxLogo from "@/static/images/caprx-logo.svg?url";

import FindBestPriceSearch from "@/components/FindBestPriceSearch";

import styles from "./WhiteLabelHomeHero.module.scss";

export const HomeHero = () => {
  const { H1 } = Heading;
  const { clientDisplayName } = useContext(ThemeSelectorContext);

  return (
    <div className={styles.WhiteLabelHomeHero}>
      <Shelf>
        <div className={styles.WhiteLabelHomeHeroImage}>
          <Image src={pillBottles} alt="image of pill bottles" />
        </div>
        <Stack spacing="medium-large" className={styles.WhiteLabelHomeHeroSearch}>
          <div role="img" aria-label="client logo" className={styles["LogoImage"]} />
          <H1 roboto className={styles.WhiteLabelHomeHeroHeading}>
            Save up to 90%
            <br />
            on your prescriptions *
          </H1>
          <p className={styles.WhiteLabelHomeHeroSubHeading}>
            with the FREE <span className={styles.ClientName}>{clientDisplayName}</span> Advantage card
          </p>
          <Stack>
            <FindBestPriceSearch />
            <Body className={styles.WhiteLabelHomeHeroPoweredBy}>
              Powered by <Image src={CapRxLogo} alt="Capital Rx Logo" />
            </Body>
            <Body>*Based on the difference between the U&C submitted by the pharmacy and the price the patients pay</Body>
          </Stack>
        </Stack>
      </Shelf>
    </div>
  );
};
